import { Link } from 'react-router-dom';
import { servicesData } from '../../../mocks/services';

const ServicesSection = () => {
  return (
    <section className="py-24 bg-neutral-50">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-secondary/10 rounded-full mb-6">
            <span className="text-secondary font-semibold text-sm">Hizmetlerimiz</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-6 font-heading">
            2. El Bilgisayar Alım Satım ve Teknik Servis
          </h2>
          <p className="text-neutral-600 text-lg max-w-3xl mx-auto">
            İkinci el bilgisayar alım satımından profesyonel teknik servise kadar tüm ihtiyaçlarınız için yanınızdayız
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {servicesData.map((service) => (
            <Link
              key={service.id}
              to={`/hizmetler/${service.slug}`}
              className="group bg-white rounded-xl p-8 shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center bg-secondary/10 rounded-xl mb-6 group-hover:bg-secondary group-hover:scale-110 transition-all duration-300">
                <i className={`${service.icon} text-3xl text-secondary group-hover:text-white transition-colors`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-primary mb-4 group-hover:text-secondary transition-colors">
                {service.title}
              </h3>
              <p className="text-neutral-600 mb-6 leading-relaxed">{service.description}</p>

              {/* Arrow */}
              <div className="flex items-center text-secondary font-semibold text-sm group-hover:translate-x-2 transition-transform">
                <span>Detaylı Bilgi</span>
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </Link>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <Link
            to="/hizmetler"
            className="inline-flex items-center space-x-2 px-8 py-4 bg-primary text-white rounded-lg font-semibold hover:bg-primary-dark transition-colors whitespace-nowrap cursor-pointer"
          >
            <span>Tüm Hizmetleri Gör</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;